export const ADD_TO_FAVORITE = 'add_to_favorite'
export const DELETE_FAVORITE = 'delete_favorite'
export const HANDLE_DISABLE_BTN = 'handle_disable_btn'
export const SET_CURRENT_MOVIE = 'set_current_movie'
export const SET_THEME = 'set_theme'